import {BaseStyles} from '@paperlessio/sdk/api/util';

export class SubmittableStyles extends BaseStyles {
  constructor(v: Partial<SubmittableStyles> = {}) {
    super(v);
  }
}
